import Controller from '@ember/controller';
import { action, computed, set, setProperties } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import { isPresent } from '@ember/utils';

const PAGE_SIZE = 50;

export default class TasksByContactController extends Controller {
  @service contactsCache;
  @service fundsService;
  @service media;

  queryParams = ['page', 'group', { contactFilter: 'q' }];
  page = 1;
  contactFilter = '';
  group = '';

  @tracked sortedItems = [];
  // not tracking below properties because we're manually executing sort
  // after the below properties are changed
  sortByProperty = 'notComplete.length';
  sortByDirection = 'desc';

  get columnsToDisplay() {
    if (this.media.isSmallDown) {
      return 1;
    } else if (this.media.isMedium) {
      return 2;
    } else {
      return 3;
    }
  }

  get sortBy() {
    return [`${this.sortByProperty}:${this.sortByDirection}`];
  }

  sortThoseItems() {
    this.sortedItems = sortByProperties(this.model.contactItems, this.sortBy);
  }

  @computed('sortedItems', 'contactFilter', 'group')
  get filteredItems() {
    let items = this.sortedItems;
    if (isPresent(this.group)) {
      let groupContactIds = {};
      this.contactsCache.groupContacts[this.group].contacts.forEach((x) => {
        groupContactIds[x.id] = true;
      });
      items = items.filter((x) => groupContactIds[x.contact.id]);
    }
    if (
      this.sortedItems.length === 0 ||
      (this.contactFilter?.length || 0) <= 1
    ) {
      return items;
    }
    let matchedContactIds = {};
    this.contactsCache.search(this.contactFilter).forEach((contact) => {
      matchedContactIds[contact.id] = true;
    });

    return items.filter((x) => matchedContactIds[x.contact.id]);
  }

  @computed('page', 'filteredItems')
  get pagedItems() {
    let offset = (this.page - 1) * PAGE_SIZE;
    return this.filteredItems.slice(offset, offset + PAGE_SIZE);
  }

  get totalPages() {
    return Math.ceil(this.filteredItems.length / PAGE_SIZE);
  }

  get availableGroupOptions() {
    return [
      {
        val: '',
        label: 'Filter by Groups',
      },
    ].concat(
      this.contactsCache.sortedGroups.map((x) => {
        return { val: x, label: x };
      }),
    );
  }

  @action
  templateDidInsert() {
    this.sortThoseItems();
  }

  @action
  templateWillDestroy() {
    setProperties(this, {
      contactFilter: '',
      group: '',
      page: 1,
    });
  }

  @action
  handleFilterByGroup(group) {
    set(this, 'group', group);
  }

  @action
  handleFilterGroupSelectChanged(e) {
    this.handleFilterByGroup(e.target.value);
  }

  @action
  handleContactFilterInput(e) {
    setProperties(this, {
      contactFilter: e.target.value,
      page: 1,
    });
  }

  @action
  handlePageChange(newPage) {
    set(this, 'page', newPage);
  }

  @action
  updateSortBy(property) {
    let direction = 'asc';
    if (this.sortByProperty === property) {
      direction = this.sortByDirection === 'asc' ? 'desc' : 'asc';
    }
    this.sortByProperty = property;
    this.sortByDirection = direction;
    this.sortThoseItems();
  }
}
